"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAddress = void 0;
const address_1 = require("@zondax/izari-filecoin/address");
const validateAddress = (input) => {
    try {
        const bytes = address_1.Address.fromString(input).toBytes();
        return { isValid: true, bytes };
    }
    catch (error) {
        return { isValid: false };
    }
};
exports.validateAddress = validateAddress;
//# sourceMappingURL=addresses.js.map